import { Endpoint, type Method } from '@criteria-labs/docs-kit'
import clsx from 'clsx'

const methodColors: Record<Method, string> = {
  get: 'text-sky-600 dark:text-sky-400',
  put: 'text-emerald-600 dark:text-emerald-400',
  post: 'text-emerald-600 dark:text-emerald-400',
  delete: 'text-red-600 dark:text-red-400',
  options: 'text-zinc-600 dark:text-zinc-400',
  head: 'text-zinc-600 dark:text-zinc-400',
  patch: 'text-lime-600 dark:text-lime-400',
  trace: 'text-yellow-600 dark:text-yellow-400'
}

export function EndpointLine({ endpoint }: { endpoint: Endpoint }) {
  return (
    <code className="text-xs">
      <span className={clsx(methodColors[endpoint.method])}>{endpoint.method.toUpperCase()}</span>
      &nbsp;{endpoint.path}
    </code>
  )
}
